const state = {
  devSearchItem: {},
};

const mutations = {
  SET_ITEM(state, item = {}) {
    state.devSearchItem = item;
  },
};

export default {
  namespaced: true, // 开启命名空间，避免全局命名冲突
  state,
  mutations,
};
